import { useEffect } from 'react';
import { HeroSection } from '../components/landing/HeroSection';

const LandingPage = () => {
  useEffect(() => {
    // Smooth scroll behavior for anchor links
    const handleSmoothScroll = (e: Event) => {
      const target = e.target;
      if (target instanceof HTMLAnchorElement && target.hash) {
        e.preventDefault();
        const element = document.querySelector(target.hash);
        element?.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => link.addEventListener('click', handleSmoothScroll));

    return () => {
      links.forEach(link =>
        link.removeEventListener('click', handleSmoothScroll)
      );
    };
  }, []);

  return <HeroSection />;
};

export default LandingPage;
